import { HTMLAttributes, forwardRef } from 'react'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'elevated'
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ variant = 'default', className = '', children, ...props }, ref) => {
    const baseClasses = 'border rounded-lg sm:rounded-xl p-3 sm:p-4'

    const variantClasses: Record<NonNullable<CardProps['variant']>, string> = {
      default: 'bg-background-card border-border',
      elevated: 'bg-background-elevated border-border-muted',
    }

    return (
      <div
        ref={ref}
        className={`${baseClasses} ${variantClasses[variant]} ${className}`}
        {...props}
      >
        {children}
      </div>
    )
  }
)

Card.displayName = 'Card'
